export const version = 'kunde-v1.20.0-SNAPSHOT-0e748c05048c15206b7e501185ad32b96399a1e7';